import React, { useState, useEffect,useRef, useLayoutEffect } from 'react';
import {Main,Axios,Loading,usePaginacion,Paginacion} from '../../../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf,faWindowClose,faFileExcel,faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import DatePicker from "react-datepicker";
import BusquedaSinForm from '../../../componentes/BusquedaSinForm';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import Swal from 'sweetalert2';
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {formatearMontoMoneda} from '../../../Helpers/utilidades-globales'
import { useHistory } from "react-router-dom";
import { TrashIcon } from '@heroicons/react/24/outline';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import {formatearComparacion,formatoMoneda,hacerfocoEnPrimerInput,seleccionarTextoInput} from '../../../Helpers/utilidades-globales';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../../../Helpers/fechas';
import ReportesEgresosIntegrados from '../../../reportes/ReportesEgresosIntegrados';
import ImpresionPDF from '../../../componentes/ImpresionPDF';
import { 
    Button, 
    Card, 
    Checkbox, 
    Input, 
    Option, 
    Select, 
    Spinner, 
    Typography, 
    Tabs, 
    Tab,
    TabPanel,
    TabsHeader, 
    TabsBody,
    Switch,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter
} from '@material-tailwind/react';
import { convertirMesAñoAfechaCompleta } from '../../ReporteIngresosIntegrales';
import { Tabla } from '../componentes/Tabla';
import { TablaMobile } from '../componentes/TablaMobile';
import { ImprimirDetalleEgreso } from '../../../impresiones/detalle-egreso';

const initParams = {
    id_tanda:103,
    tipo: 'tipo-rg',
    id_año_fiscal:null,
    mesAño:null,
    año:null,
    id_obrero: null,
    criterio:'',
    destino: 'pastor',
    nombre_destino:'',
    id_obrero:null,
    isexterno: false,
    id_iglesia:null,
    id_proveedor:null,    
    id_provincia: null,  
    id_region: null,
    id_fondo_tesoreria: null,
    usuario_alta: null,   
    tipo_recibo: null,                                       
    formapago:null,
    rubro:null,
    fondo:null,
    moneda:1,
    caja:null,
    fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
    fechaHasta:new Date(),
    fecha:new Date(),
    descripcionCriterio:'',
    total_caja:false,
    total_diario:false,
    total_mensual:false,
    fdo_regiones: false,
    tipo_formapago: null,
    formapago: null,
    hiddenCols: [],
    total_año:false,
    nro_desde: null,
    nro_hasta: null,
    orden: null,
    no_agrupar:false
}

export default function DetalleIngreso(){
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [IsFetchingData, setIsFetchingData] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const { esCelular } = useContextoGlobal();
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const [contadorConsulta,setContadorConsulta]=useState(0);   
    const [parametros,setParametros]=useState(initParams)
    const [formaPagos,setFormaPagos]=useState([]);
    const [openFPago,setOpenFPago] = useState(false);
    const [provincias,setProvincias] = useState([]);
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [tandas,setTandas] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [monedas,setMonedas] = useState([]);
    const [cajas,setCajas] = useState([]);
    const [fondos,setFondos] = useState([]);
    const [formasPago,setFormasPago] = useState([]);
    const [obreros,setObreros] = useState([]);
    const [backUpObreros,setBackUpObreros] = useState([]);
    const [bancos,setBancos] = useState([]);
    const [iglesias,setIglesias] = useState([]);
    const [tiposMovBanco,setTiposMovBanco] = useState([]);
    const [terminalesUsers,setTerminalesUsers] = useState([]);
    const [regiones,setRegiones] = useState([]);
    const [tipoRecibos,setTipoRecibos] = useState([]);
    const [comprEgresos,setComprEgresos] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [activeTab, setActiveTab] = useState('datosE');
    const [isFormasPagoEdit, setIsFormasPagoEdit] = useState(false);
    const [id_ingreso, setIdIngreso] = useState(null);
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false)
    const meses = [0,1,2,3,4,5,6,7,8,9,10,11,12];
    const {configuracion,paginar,inicializar} = usePaginacion();
    const history = useHistory();
    const nombreCriterio = useRef('Seleccione el año fiscal:')
    registerLocale('es', es)


    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
        if (localStorage.getItem('ingresoId')) {
            const ingresoDetalle = JSON.parse(localStorage.getItem('ingresoId'));
            setIdIngreso(ingresoDetalle.id_ingreso);
            buscarIngresoInfo(ingresoDetalle.id_ingreso);
        } else {
            history.push('/egresos/crear') 
        }
    },[])

    useEffect(()=>{
        if (formasPago.length > 0) setIsFormasPagoEdit(true);
    },[formasPago])

      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/tandas'),
            Axios.get('/api/tablasgenerales/reportes/perfiscales'),
            Axios.get('/api/tablasgenerales/rubrosingresos'),
            Axios.get('/api/reportes/tablas/monedas'),
            Axios.get('/api/reportes/tablas/cajas'),
            Axios.get('/api/reportes/tablas/fondos'),
            Axios.get('/api/reportes/tablas/formaspago'),
            Axios.get('/api/tablasgenerales/provincias'),
            Axios.get('/api/tablasgenerales/terminales-usuarios'),
            Axios.get('/api/tablasgenerales/tipo-recibos'),
            Axios.get('/api/tablasgenerales/regiones'),
            Axios.get('/api/tablasgenerales/obreros')])
            setTandas(vectorResultados[0].data)
            setPeriodosFiscales(vectorResultados[1].data.reverse())
            setRubros(vectorResultados[2].data)
            setMonedas(vectorResultados[3].data)
            setCajas(vectorResultados[4].data)
            setFondos(vectorResultados[5].data)
            setFormasPago(vectorResultados[6].data)
            setProvincias(vectorResultados[7].data)
            setTerminalesUsers(vectorResultados[8].data)
            setTipoRecibos(vectorResultados[9].data)
            setRegiones(vectorResultados[10].data)
            setObreros(vectorResultados[11].data)
            setBackUpObreros(vectorResultados[11].data)
            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const buscarIngresoInfo = async (id_ingreso) => { 
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([
                Axios.get('/api/tablasgenerales/ingresos/detalle/'+id_ingreso),
                Axios.get('/api/tablasgenerales/ingresos/detalle/pagos/'+id_ingreso),
                Axios.get('/api/tablasgenerales/ingresos/detalle/pagos/libro/'+id_ingreso),
            ])
            const ingreso = vectorResultados[0].data;
            const pagos = vectorResultados[1].data;
            const libro = vectorResultados[2].data;

            setParametros({
                ...parametros,
                fecha: moment(ingreso[0].fecha).format('DD/MM/YYYY HH:mm'),
                usuario_alta: ingreso[0].usuario_alta,
                id_ingreso: ingreso[0].id_ingreso,
                id_tanda: ingreso[0].id_tanda,
                id_rubro: ingreso[0].id_rubro,
                id_obrero: ingreso[0].id_obrero,
                id_iglesia: ingreso[0].id_iglesia,
                id_tipo_comp_egr: ingreso[0].id_tipo_comp_egr,
                monto: Number(ingreso[0].monto),
                tipo_recibo: ingreso[0].tipo_compr,
                nro_comprobante: ingreso[0].nro_comprobante,
                formaPagos: pagos.map((pago) => {
                    const foundLib = libro.find(lib => Number(pago.cod_op_lib_banco ?? 0) === Number(lib.cod_op_lib_banco));
                    return { 
                        tipo_formapago: pago.cod_op_lib_banco ? 'Mov. Banco' : 'Efectivo',
                        m_bruto: pago.monto_bruto,
                        v_cambio_pesos: pago.valor_cambio,
                        m_neto: pago.monto_neto,
                        tipo_movimiento: foundLib?.id_tipo_mov_banco,
                        n_comprobante: foundLib?.numero_comprobante,
                        f_emision: foundLib?.f_alta ? moment(foundLib.f_alta).format('DD-MM-YYYY HH:mm') : null,
                        f_acreditacion: foundLib?.fecha_acreditacion ? moment(foundLib?.fecha_acreditacion).format('DD-MM-YYYY HH:mm') : null,
                        id_banco: foundLib?.id_banco
                    }
                })
            })

            setTimeout(() => { 
                console.log(parametros);
            }, 1000);

            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const goToEgresoList = ()=>{
        history.push('/egresos')
    }

    const buscarIglesiasPorObrero = async (e)=>{
        const id_obrero = e.target.value;
        setParametros({...parametros, id_obrero, id_iglesia: null});
        try{
            if (!id_obrero) {
                setIglesias([]);
                return;
            }
            const iglesias = await Axios.get('/api/tablasgenerales/iglesiasobrero/'+id_obrero)
            setIglesias(iglesias.data)
        }catch(err){
            console.log('Error al buscar los datos generales')  
        }
    }

    const iniciarGrabarEgreso = () => {
        Swal.fire({
            text: 'Está seguro de guardar los cambios?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                  grabarEgreso();
                } else console.log("Se canceló la creación de un nuevo egreso")
            }
        )
    }

    const grabarEgreso = async () => { 
        setIsFetchingData(true);
        try { 
            let dataSubmit = {
                cod_op_egr: generarCodigoUnico(),
                fecha: convertirMesAñoAfechaCompleta(parametros.fecha),
                id_tanda: parametros.id_tanda ? Number(parametros.id_tanda) : null,
                id_rubro: parametros.rubro ? Number(parametros.rubro) : null,
                id_obrero: parametros.id_obrero ? Number(parametros.id_obrero) : null,
                id_iglesia: parametros.id_iglesia ? Number(parametros.id_iglesia) : null,
                id_proveedor: parametros.id_proveedor ? Number(parametros.id_proveedor) : null,
                descripcion: parametros.descripcion,
                borrador: parametros.solo_borradores ?? 0,
                id_tipo_comp_egr: parametros.id_tipo_comp_egr,
                nro_comprobante: parametros.nro_comprobante,
                solo_efectivo: parametros.solo_efectivo,
                monto: parametros.monto,
                id_rubro: parametros.id_rubro ? Number(parametros.id_rubro) : null,
                id_caja: parametros.id_caja ? Number(parametros.id_caja) : null,
                id_tipo_moneda: parametros.id_tipo_moneda ? Number(parametros.id_tipo_moneda) : null,
                formaPagos: isFormasPagoEdit ? formaPagos : []
            };

            console.log(dataSubmit);
            const dataCreacion = await Axios.post('/api/tablasgenerales/egresos/grabar', dataSubmit);
            setDatos(dataCreacion.data); 
            setIsFetchingData(false);     
            Swal.fire(`Egreso guardado con éxito`,'','info')        
        } catch (error) {
            console.log('Error al ejecutar la búsqueda', error);
            setIsFetchingData(false);
            Swal.fire(`No se pudo guardar el nuevo egreso`,'','error')
        }
    }

    const impDetallEgreso = async () => { 
        
        const newData = {
            ...parametros,
            proveedor: proveedores.find(prov => prov.id_proveedor === parametros.id_proveedor)?.nombre,
            caja: cajas.find(caja => caja.id_caja === parametros.id_caja)?.nombre,
            tanda: tandas.find(tanda => tanda.id_tanda === parametros.id_tanda)?.nombre,
            rubro: rubros.find(rubro => rubro.id_rubro === parametros.id_rubro)?.nombre,
            moneda: monedas.find(moneda => moneda.id_tipo_moneda === parametros.id_tipo_moneda)?.nombre,
            comporbante_egreso: comprEgresos.find(compr => compr.id_tipo_comp_egr === parametros.id_tipo_comp_egr)?.nombre,
            formaPagos: parametros.formaPagos.map((formaPago) => ({
                ...formaPago,
                tipo_movimiento: tiposMovBanco.find(tipo => tipo.id_tipo_mov_banco === formaPago.tipo_movimiento)?.nombre,
            }))
        }

        ImprimirDetalleEgreso(newData, parametros.fecha, "");
    }

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        console.log("parametros", parametros);
        reinicializarCriterios(setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const cleanUpData = () => { 
        setDatos([]);
    }

    const reinicializarCriterios = (setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)=>{
        setParametros({
            ...parametros,
            criterio : nuevoCriterio,
            id_tanda:tandas[0].id_tanda,
            id_año_fiscal:null,
            fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
            fechaHasta:new Date(),
            fecha:new Date(),
            mesAño:new Date(),
            año:new Date(),
        })
    }

    const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{
        switch(nuevoCriterio){
            case 'tanda' : nombreCriterio.current = 'Seleccione la tanda:';return
            case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
            case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
            case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
            case 'año' : nombreCriterio.current = 'Seleccione el año:';return
            case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
        }
    }

    const goToIngresoList = ()=>{
        // Volvemos con restoreSearch para que el listado recupere la búsqueda previa
        // (permite reenviar recibos sin tener que buscar de nuevo).
        history.push({ pathname: '/ingresos-t', state: { restoreSearch: true } });
    }

    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        {!datos.length && <div className={'mr-6 ml-6'}>
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    Detalle Ingreso
                </Typography>
            </div>

            <Tabs value="datosE" className="max-w-full mt-6 bg-white tabs-egresos">
                <TabsHeader
                    className="bg-transparent"
                    indicatorProps={{
                        className: "bg-gradient-to-tr from-blue-600 to-blue-400 shadow-none !text-white",
                    }}
                >
                    <Tab 
                        value={"datosE"} 
                        onClick={() => setActiveTab('datosE')}
                        className={`font-semibold ${activeTab==='datosE' ? '!text-white' : ''}`}
                    >
                        Datos del Ingreso
                    </Tab>
                    <Tab 
                        value={"formaP"} 
                        onClick={() => setActiveTab('formaP')}
                        className={`font-semibold ${activeTab==='formaP' ? '!text-white' : ''}`}
                    >
                        Forma de Pago
                    </Tab>

                </TabsHeader>
                <TabsBody>

                    <TabPanel value={"datosE"}>
                        <Parametros parametros = {parametros} 
                            setParametros={setParametros} 
                            tandas={tandas} 
                            periodosFiscales ={periodosFiscales} 
                            buscarIglesiasPorObrero ={buscarIglesiasPorObrero}
                            centrado={contadorConsulta==0 ? true : false}
                            cajas = {cajas}
                            rubros = {rubros}
                            monedas = {monedas}
                            fondos = {fondos}
                            formasPago = {formasPago}
                            obreros = {obreros}
                            proveedores = {proveedores}
                            iglesias = {iglesias}
                            tiposMovBanco = {tiposMovBanco}
                            comprEgresos = {comprEgresos}
                            iniciarGrabarEgreso={iniciarGrabarEgreso}
                            IsFetchingData = {IsFetchingData}
                            formaPagos= {formaPagos}
                            id_ingreso = {id_ingreso}
                            setObreros = {setObreros}
                            provincias = {provincias}
                            impDetallEgreso = {impDetallEgreso}
                            backUpObreros = {backUpObreros}
                            goToEgresoList={goToEgresoList}
                            handleCheckCriterio = {handleCheckCriterio}
                            terminalesUsers = {terminalesUsers}
                            tipoRecibos = {tipoRecibos}
                            history = {history}
                        />
                    </TabPanel>

                    <TabPanel value={"formaP"}>
                        <FormasPago parametros = {parametros} 
                            formaPagos={parametros.formaPagos}
                            setOpenFPago={setOpenFPago}
                            tiposMovBanco={tiposMovBanco}
                            bancos={bancos}
                            monto={parametros.monto ?? 0}
                        />
                    </TabPanel>
                </TabsBody> 
            </Tabs> 

            <div className='flex justify-center gap-2 mt-1 mb-1'>
                <Button className="mt-4 w-48 flex justify-center bg-gray-900" onClick={goToIngresoList}>
                    Regresar 
                </Button>
            </div>   
        </div>}

        {esCelular && datos.length > 0 && <TablaMobile registrosAmostrar={datos} cleanUpData={cleanUpData} />}

        {!esCelular && datos.length > 0 && <Tabla
            registrosAmostrar={datos}
            cleanUpData={cleanUpData}
        />}
    </Main>
    )
}

function Parametros({parametros,
                    setParametros,
                    cajas,
                    tandas,
                    buscarIglesiasPorObrero,
                    periodosFiscales,
                    centrado,
                    rubros,
                    tiposMovBanco,
                    comprEgresos,
                    monedas,
                    fondos,
                    obreros,
                    id_ingreso,
                    proveedores,
                    iglesias,
                    history,
                    formaPagos,
                    terminalesUsers,
                    tipoRecibos,
                    IsFetchingData,
                    backUpObreros,
                    setObreros,
                    provincias,
                    handleCheckCriterio,
                    impDetallEgreso,
                    goToEgresoList,
                    iniciarGrabarEgreso,
                    setNombreCriterio}){

    const inputBusquedaRef = useRef()
    const r2 = useRef('null')

    const [buscarDestino,setBuscarDestino] = useState(false)
    const { esCelular} = useContextoGlobal();

    const handleChangeNombre = (e)=>{
        setParametros({...parametros,nombre_destino : e.target.value})
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'tanda'})
    }

    const handleCheckNoAgrupar = (e)=>{
        setParametros({...parametros,no_agrupar : parametros.no_agrupar ? null : e.target.name=="checknoagrupar" ? 1 : e.target.value})
    }

    const handleCheckTotalCaja = (e)=>{
        setParametros({...parametros,total_caja : parametros.total_caja ? false : true})
    }

    const handleCheckTotalDiario = (e)=>{
        setParametros({...parametros,total_diario : parametros.total_diario ? false : true})
    }

    const handleCheckTotalMensual = (e)=>{
        setParametros({...parametros,total_mensual : parametros.total_mensual ? false : true})
    }

    const handleCheckTotalAño = (e)=>{
        setParametros({...parametros,total_año : parametros.total_año ? false : true})
    }

    const validarParametros = ()=>{
        if (parametros.destino=="proveedor" && !parametros.id_proveedor){
            alert('Falta seleccionar un proveedor')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="pastor" && !parametros.id_obrero){
            alert('Falta seleccionar un ministro')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="iglesia" && !parametros.id_iglesia){
            alert('Falta seleccionar una iglesia')
            inputBusquedaRef.current.focus()
            return
        }

        if (parametros.descripcion == null){
            alert('Falta añadir una descripción')
        }

        if (parametros.fecha == null){
            alert('Falta añadir una fecha')
        }

        if (parametros.id_tipo_moneda == null){
            alert('Falta seleccionar una moneda')
            return
        }

        if (parametros.monto === 0){
            alert('El monto no puede ser cero')
            return
        }

        if (calcularSaldoPago(parametros.monto,formaPagos) > 0){
            alert('Por favor justifique el monto del egreso con la forma de pago')
            return
        }

        //iniciarGrabarEgreso()
    }

    const limpiarFiltros = () => { 
        setParametros(initParams);
    }

    const getNombreAportante = ()=> {
        return parametros.id_iglesia
                ? (iglesias.find(i => i.id_iglesia === parametros.id_iglesia)?.nombre ?? '--')
                    : parametros.id_obrero
                        ? (obreros.find(o => o.id_obrero === parametros.id_obrero)?.nombre ?? '--')
                            : parametros.id_proveedor
                                ? (proveedores.find(p => p.id_proveedor === parametros.id_proveedor)?.nombre ?? '--')
                                : ''
    }

    const getLabelAportante = ()=> {
        return parametros.id_iglesia
                ? 'Iglesia'
                    : parametros.id_obrero
                        ? 'Ministro'
                            : parametros.id_proveedor
                                ? 'Proveedor'
                                : ''
    }

    const deleteEgreso = async () => { 
        Swal.fire({
            text: '¿Está seguro de eliminar este egreso?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Axios.delete('/api/tablasgenerales/egresos/borrar', { id_ingreso });
                        Swal.fire(`Egreso eliminado con éxito`,'','info');
                        setTimeout(() => {
                            history.push('/egresos');
                        }, 2000);
                    } catch (error) { 
                        console.log("Error al eliminar el egreso", error);
                        Swal.fire(`Error al eliminar el egreso`,'','error')
                    }
                } else console.log("Se canceló la creación de un nuevo egreso")
            }
        )
    }
    
    return <Card className="mt-4 w-full p-10 mb-10">
                <div className="flex f-col">
                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className='w-[220px]'>
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Fecha:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Fecha" 
                                                value={parametros.fecha}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />                                        
                                        </div>   
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Ministro:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="N° Comprobante" 
                                                value={obreros.find(obr => obr.id_obrero === parametros.id_obrero)?.nom_simple ?? '--'}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div>
                                </div> 
                            </div>
                        </Card>

                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Monto:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Monto" 
                                                value={parametros.monto ? formatearMontoMoneda(parametros.monto) : '0.00'}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div> 
                                </div>

                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Usuario alta:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Usuario Alta" 
                                                value={parametros.usuario_alta ?? '--'}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div> 
                                </div>
        
                                {/* Segunda columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Tipo Recibo:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Usuario Alta" 
                                                value={parametros.tipo_recibo ?? '--'}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div> 
                                </div>

                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            N° de Comprobante:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Usuario Alta" 
                                                value={parametros.nro_comprobante ?? '--'}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div> 
                                </div>

                                {/* Tercera columna */}
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Descripción:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Descripción" 
                                                value={parametros.descripcion ?? '--'}
                                                maxLength={200}
                                                disabled={true}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div> 
                                </div>
                                    
                            </div>
                        </Card>

                    {parametros.tipo=='resumen' && <div className={`${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Reporte sin agrupar en meses"
                                ripple={false}
                                name="checknoagrupar" 
                                checked={parametros.no_agrupar}
                                onClick={handleCheckNoAgrupar}
                                className='w-5 h-5'
                                />
                            </div>           
                        </div>
                    }

                    {parametros.tipo=='cronologico' && <div className={`hidden ${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Totales por caja"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_caja}
                                onClick={handleCheckTotalCaja}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales diarios"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_diario}
                                onClick={handleCheckTotalDiario}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales mensuales"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_mensual}
                                onClick={handleCheckTotalMensual}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales por año"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_año}
                                onClick={handleCheckTotalAño}
                                className='w-5 h-5'
                            />
                            </div>           
                        </div>
                       }


                    <div className={`hidden ${esCelular ? '' : 'grid grid-cols-3 justify-left'}`}>
                        <Typography variant="h5" color="blue-gray" className="mt-1">
                            Reporte:
                        </Typography>
                        <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Resumen"
                                ripple={false}
                                checked={parametros.tipo=='resumen'} 
                                id="tipo-resumen" 
                                name = "tipo" 
                                value="resumen" 
                                onClick={handleCheckTipo}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Cronológico"
                                ripple={false}
                                checked={parametros.tipo=='cronologico'} 
                                id = "tipo-crono" 
                                name="tipo" 
                                value="cronologico" 
                                onClick={handleCheckTipo}
                                className='w-5 h-5'
                            />
                        </div>           
                    </div>
            </div>
        </Card>
}

function FormasPago({
    formaPagos,
    tiposMovBanco,
    bancos,
    setOpenFPago,
    monto
}){
    
const TABLE_HEAD = ["Forma de Pago", "Banco", "Fecha Acreditación", "Monto Bruto", "Valor Cambio", "Valor Neto"];

return (
        <Card className="mt-0 w-full p-10 mb-10 relative shadow-none">
            <div className="flex f-col mt-4">
                <div className="flex mt-4 justify-between">
                    <div className='flex gap-1'>
                        <p className='flex font-semibold text-[14px] bg-[#eee]/50 rounded-md mx-2 items-center justify-center my-2 w-[150px]'>
                            Saldo de Pago
                        </p>
                        <span className='flex justify-center rounded-md items-center font-semibold bg-[#eee]/50 my-2 mx-2 min-w-[60px]'>
                            {calcularSaldoPago(monto, formaPagos)}
                        </span> 
                    </div>
                </div>

                <table className="w-full min-w-max table-auto text-left mt-4">
                    <thead>
                    <tr>
                        {TABLE_HEAD.map((head) => (
                        <th
                            key={head}
                            className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-center"
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70"
                            >
                            {head}
                            </Typography>
                        </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {formaPagos?.map((data, index) => {
                        const isLast = index === formaPagos.length - 1;
                        const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";
            
                        return (
                        <tr key={index}>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.tipo_formapago }
                                    {data.tipo_formapago !== 'Efectivo' && data.tipo_movimiento ? ` - ${tiposMovBanco.find(tipo => Number(tipo.id_tipo_mov_banco) === Number(data.tipo_movimiento))?.nombre}` : ''}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {bancos.find(banco => Number(banco.id_banco) === Number(data?.id_banco))?.nombre ?? '--'} 
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.f_acreditacion ?? '--'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.m_bruto ? formatearMontoMoneda(Number(data.m_bruto)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.v_cambio_pesos ? formatearMontoMoneda(Number(data.v_cambio_pesos)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.m_neto ? formatearMontoMoneda(Number(data.m_neto)) : '0.00'}
                                </Typography>
                            </td>
                        </tr>
                        );
                    })}

                    {!formaPagos?.length && (
                        <tr>
                            <td colSpan={TABLE_HEAD.length + 1} className="text-center p-4">
                                <Typography variant="small" color="blue-gray" className="font-normal">
                                    No hay datos disponibles
                                </Typography>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </Card>
    )
}

function Seleccionador({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    classancho
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select value={valor} name={name? name : ''} className='h-9 font-semibold text-black' onChange ={onchange} id={id? id : null} disabled={true}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]} className=''>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { valor!="*" && limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
}   

function generarCodigoUnico() {
    const now = new Date();
    const codigo = 
        now.getFullYear() + // Año
        String(now.getMonth() + 1).padStart(2, '0') + // Mes (con 0 inicial si es necesario)
        String(now.getDate()).padStart(2, '0') + // Día (con 0 inicial si es necesario)
        String(now.getHours()).padStart(2, '0') + // Hora (con 0 inicial si es necesario)
        String(now.getMinutes()).padStart(2, '0') + // Minutos (con 0 inicial si es necesario)
        String(now.getSeconds()).padStart(2, '0') + // Segundos (con 0 inicial si es necesario)
        String(Math.floor(Math.random() * 1000)).padStart(3, '0'); // Número aleatorio de 3 dígitos

    return codigo;
}

function calcularSaldoPago(montoEgreso, formaPagos) {
    const totalPagos = formaPagos?.reduce((total, pago) => {
        return total + (parseFloat(pago.m_neto) || 0);
    }, 0);

    const saldo = montoEgreso - totalPagos;

    return saldo;
}